import { cn } from "@/lib/utils";
import Button from "@mui/material/Button";
import { useState } from "react";
interface ChatFollowupsProps {
  questions?: string[] | null;
  onSend?: (question: string) => void;
}
export function ChatFollowups({
  questions,
  onSend: onSendFollowup,
}: ChatFollowupsProps) {
  const [visibility, setVisibility] = useState({ questions, expanded: true });
  // New suggestions open immediately, without an effect causing another paint.
  if (visibility.questions !== questions) {
    setVisibility({
      questions,
      expanded: questions?.length ? true : visibility.expanded,
    });
  }
  const showFollowups = visibility.expanded;
  return (
    <>
      {questions && questions.length > 0 && (
        <div className="absolute bottom-full left-0 right-0 mb-2 z-50">
          <Button
            variant="text"
            type="button"
            onClick={() =>
              setVisibility({ questions, expanded: !showFollowups })
            }
            className="flex items-center gap-1.5 cursor-pointer"
            aria-expanded={showFollowups}
            aria-label={`Suggested follow-ups (${questions.length})`}
            sx={{
              minWidth: 0,
              color: "var(--muted-foreground)",
              backgroundColor: "transparent",
              "&:hover": {
                color: "var(--foreground)",
                backgroundColor: "transparent",
              },
            }}
          >
            <span
              className={cn(
                "transition-transform duration-150 inline-block",
                showFollowups && "rotate-90",
              )}
            >
              &#9654;
            </span>
            <span>Follow-ups</span>
          </Button>
          {showFollowups && (
            <div
              className="flex flex-wrap gap-1.5 mt-1"
              role="group"
              aria-label="Follow-up suggestions"
            >
              {questions.map((q, i) => (
                <Button
                  key={i}
                  variant="text"
                  type="button"
                  onClick={() => onSendFollowup?.(q)}
                  className="text-left cursor-pointer"
                  sx={{
                    fontSize: "0.75rem",
                    padding: "0.375rem 0.75rem",
                    borderRadius: "9999px",
                    border: "1px solid var(--border)",
                    backgroundColor: "var(--background)",
                    color: "var(--muted-foreground)",
                    "&:hover": {
                      color: "var(--foreground)",
                      borderColor: "var(--primary-40)",
                      backgroundColor: "var(--primary-10)",
                    },
                  }}
                >
                  {q}
                </Button>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
